import { useMainContext } from '@/services/context';
import * as React from 'react';
import { Main } from './main';
import { Results } from './results';

export const Router: React.FC = () => {
  const { votingFeatures } = useMainContext();

  if (!votingFeatures) {
    return <Main />;
  }

  return <Results />;
};
